// -----------------------------------------------------------------------------
// 初期設定 - ダイアログアクション
// -----------------------------------------------------------------------------
import axios from 'axios';
import appConfig from '@/config';
import configureStore, {persistor} from '../reducks/store';
import {authOperations} from '../reducks/auth';
import {history} from './history';

// Reduxストア
const reduxStore = configureStore();
const dispatch = reduxStore.dispatch;

/**
 * メニュー再読み込み
 */
export async function reloadMenu() {

  // トップ画面に遷移
  history.navigate('/');
}

/**
 * ユーザー情報再読み込み
 */
export async function reloadUser() {
  // ユーザー情報再読み込み (force=true)
  const action = authOperations.getUserInfoOperation(true);
  await dispatch(action);

  // メニュー再読み込み
  await reloadMenu();
}

/**
 * ログインページに戻る
 */
export async function backToLogin() {
  // ログアウト
  const action = authOperations.doLogoutOperation(history.navigate);
  await dispatch(action);
}

/**
 * フロントエンド再読み込み
 */
export async function superReload() {
  // ログアウト
  const action = authOperations.doLogoutOperation(() => {
    console.log('Purge store and reload page', window.location.href);

    // Reduxストアをクリア
    persistor.purge();

    // ページリロード (ログイン画面表示)
    window.location.reload();
  });
  dispatch(action);
}

// ------------------------------------------------------------------------------
// ヘルパメソッド
// ------------------------------------------------------------------------------
/**
 * メニュー有効/無効判定
 *
 * @return {Promise<boolean>} 有効なメニュー項目がある場合 true
 */
export async function menuAvailable() {
  const getMenuUrl = appConfig.API_URL + 'scz1002/get-menu-items';

  // メニュー取得API実行
  try {
    const res = await axios.get(getMenuUrl, {
      validateStatus: (status) => true,   // エラーにしない
      custom: {skipUpdateStatus: true},   // 状態更新しない
    });

    // メニュー項目有効判定
    if (res.status === axios.HttpStatusCode.Ok) {
      const items = res.data?.menuItems;
      if (items?.length > 0 && items[0].roleId) {
        return true;
      }
    }
  } catch (err) {
    console.log('Failed to get menu items', err);
  }
  return false;
}

// ------------------------------------------------------------------------------
// エクスポート
// ------------------------------------------------------------------------------
export default {
  // ダイアログアクション
  reloadMenu,
  reloadUser,
  backToLogin,
  superReload,

  // 状態判定
  menuAvailable,
};
